/**
 * Assigns a new URL to the current browser location.
 * Extracted to a standalone function so tests can mock it without touching window.location.
 *
 * Used by HandoffSuccess deeplink fallback (WEB-356 #4).
 */
export function deeplinkNavigate(url: string): void {
  window.location.assign(url);
}
